import React, {createContext, useContext} from 'react'

export interface ContextUiLocationProps {
  path?: string[]
}

const UiLocation = createContext<ContextUiLocationProps>({
  path: []
})

export const useUiLocation = (): ContextUiLocationProps => {
  return useContext(UiLocation)
}

/**
 * Provides current location to all children components. With this context you can get current location of the component in ui structure.
 * It's useful for shared components that should know their location in the ui structure.
 * @param taskId
 * @param children
 * @constructor
 */
export const UiLocationProvider = ({
  location,
  children
}: {
  location: string
  children: React.ReactNode
}) => {
  const parentLocation = useUiLocation()
  return (
    <UiLocation.Provider
      value={{path: (parentLocation.path || []).concat([location])}}
    >
      {children}
    </UiLocation.Provider>
  )
}
